import { Button, ButtonProps } from '@material-ui/core';
import { Col } from 'components/Col';
import './CustomRouteButton.scss';
import { Row } from 'components/Row';

interface CustomRouteButtonProps {
  backButtonProps: ButtonProps;
  saveButtonProps: ButtonProps;
  isLabelRequiredVisible?: boolean;
}

export const CustomRouteButton = ({
  isLabelRequiredVisible = true,
  backButtonProps,
  saveButtonProps,
}: CustomRouteButtonProps) => {
  return (
    <>
      <Row className='custom-route-button__container-bloco'>
        <Col
          cols={[12, 12, 6, 6, 6]} style={{ padding: 0 }}>

          <div className={`custom-route-button 
      ${isLabelRequiredVisible
              ? 'custom-route-button--default'
              : 'custom-route-button--flex'
            }`}
          >
            <div
              className={`custom-route-button__legend 
        ${isLabelRequiredVisible
                  ? 'custom-route-button__legend--visible'
                  : 'custom-route-button__legend--hidden'
                }`}
            >
              * Campo obrigatório
            </div>
          </div>
        </Col>

        <Col
          cols={[12, 12, 6, 6, 6]} style={{ padding: 0 }}>
          <div className='custom-route-button__container-btn'>
            <div className='custom-route-button__container-unit'>
              <Button
                {...backButtonProps}
                variant='contained'
                className='custom-route-button__btnBack'
              />
            </div>
            <div className='custom-route-button__container-unit'>
              <Button
                {...saveButtonProps}
                variant='contained'
                className='custom-route-button__btnSave'
              />
            </div>
          </div>
        </Col >
      </Row>
    </>
  );
};
